<ng-container *ngIf="candidates$ | async as candidates">
  <ng-container *ngIf="candidatesVisible$ | async as visiblecandidates">
    <div class="w-100 d-flex flex-wrap">
      <ng-container *ngIf="groups$ | async as groups">
        <div class="btn-group mr-3" dropdown [insideClick]="false">
          <button
            dropdownToggle
            type="button"
            class="btn btn-white d-flex align-items-center"
          >
            <span class="mr-1">Groep: </span><b>{{ groupname$ | async }}</b
            ><span class="ml-3 mdi mdi-chevron-down"></span>
          </button>
          <ul *dropdownMenu class="dropdown-menu" role="menu">
            <label
              role="menuitem"
              *ngFor="let c of groups | sort : 'groupName'"
              class="form-check-label w-100"
              [for]="c.groupId"
            >
              <div class="form-check form-check-inline dropdown-item">
                <input
                  class="form-check-input"
                  type="radio"
                  [id]="c.groupId"
                  [value]="c.groupId"
                  [checked]="c.selected"
                  (change)="classFilterChanged($event, c.groupId)"
                />
                <label class="form-check-label" [for]="c.groupId">
                  {{ c.groupName }}</label
                >
              </div>
            </label>
          </ul>
        </div>
      </ng-container>
      <div class="btn-group mr-3" dropdown [insideClick]="true">
        <button
          dropdownToggle
          type="button"
          class="btn btn-white d-flex align-items-center"
        >
          <span class="mr-1">Jaargroep: </span
          ><b>{{ yeargroupPlaceholder$ | async }}</b>
          <span class="ml-3 mdi mdi-chevron-down"></span>
        </button>
        <ul *dropdownMenu class="dropdown-menu" role="menu">
          <label
            role="menuitem"
            class="form-check-label w-100"
            for="allejaargroepen"
          >
            <div class="form-check form-check-inline dropdown-item">
              <input
                class="form-check-input"
                type="checkbox"
                id="allejaargroepen"
                value="checkall"
                (change)="
                  checkUncheckAllYeargroup($event, $event.target.checked)
                "
                [checked]="allYeargroupsChecked$ | async"
              />
              <label class="form-check-label" for="allejaargroepen">
                Alle groepen</label
              >
            </div>
          </label>
          <li *ngFor="let checkbox of yeargroupFilters$ | async">
            <label
              *ngIf="yeargroupPresentInClass(checkbox, candidates)"
              role="menuitem"
              class="form-check-label w-100"
              [for]="checkbox.name"
            >
              <div class="form-check form-check-inline dropdown-item">
                <input
                  class="form-check-input"
                  class="form-check-input"
                  type="checkbox"
                  [id]="checkbox.name"
                  [checked]="checkbox.checked"
                  (change)="
                    checkUncheckYeargroup(
                      $event,
                      $event.target.checked,
                      checkbox.id
                    )
                  "
                  [disabled]="!yeargroupPresentInClass(checkbox, candidates)"
                />
                <label class="form-check-label" [for]="checkbox.name">
                  {{ checkbox.name }}
                </label>
              </div>
            </label>
          </li>
        </ul>
      </div>
      <div class="btn-group mr-3" dropdown [insideClick]="true">
        <button
          dropdownToggle
          type="button"
          class="btn btn-white d-flex align-items-center"
        >
          <span class="mr-1">Leerlingen: </span>
          <b> {{ candidatesPlaceholder$ | async }} </b>
          <span class="ml-3 mdi mdi-chevron-down"></span>
        </button>
        <ul *dropdownMenu class="dropdown-menu" role="menu">
          <label
            role="menuitem"
            class="form-check-label w-100"
            for="alleleerlingen"
          >
            <div class="form-check form-check-inline dropdown-item">
              <input
                class="form-check-input"
                type="checkbox"
                id="alleleerlingen"
                value="checkall"
                (change)="checkUncheckAllCandidates(allCandidatesChecked)"
                [(ngModel)]="allCandidatesChecked"
              />
              <label class="form-check-label" for="alleleerlingen">
                Alle leerlingen</label
              >
            </div>
          </label>
          <label
            *ngFor="let candidate of candidates | sort : 'name'"
            role="menuitem"
            class="form-check-label w-100"
            [for]="candidate.name"
          >
            <div class="form-check form-check-inline dropdown-item">
              <input
                class="form-check-input"
                type="checkbox"
                [checked]="candidate.checked"
                [id]="candidate.name"
                (change)="checkUncheckSingleCandidate(candidate)"
                [disabled]="!candidatePresent(candidate, visiblecandidates)"
              />
              <label
                *ngIf="(citomodule$ | async) === citomodules.Rekenen"
                class="form-check-label"
                [for]="candidate.name"
              >
                <span>{{ candidate.name }}</span>
                <span *ngIf="candidate.learningRoutesList[0]"
                  >,{{ candidate.learningRoutesList[0] }}</span
                >
                <span *ngIf="!candidate.learningRoutesList[0]"
                  >, Geen profiel,
                </span>
              </label>
              <label
                *ngIf="(citomodule$ | async) === citomodules.Spelling"
                class="form-check-label"
                [for]="candidate.name"
              >
                <span>{{ candidate.name }}</span>
                <span *ngIf="candidate.learningRoutesSpellingList[0]"
                  >,{{ candidate.learningRoutesSpellingList[0] }}</span
                >
                <span *ngIf="!candidate.learningRoutesSpellingList[0]"
                  >, Geen profiel,
                </span>
              </label>
            </div>
          </label>
        </ul>
      </div>
      <div class="btn-group mr-3" dropdown [insideClick]="true">
        <button
          dropdownToggle
          type="button"
          class="btn btn-white d-flex align-items-center"
        >
          <span class="mr-1">Profiel:</span
          ><b>{{ referenceLevelPlaceholder$ | async }}</b>
          <span class="ml-3 mdi mdi-chevron-down"></span>
        </button>
        <ul *dropdownMenu class="dropdown-menu" role="menu">
          <label
            role="menuitem"
            class="form-check-label w-100"
            for="alleroutes"
          >
            <div class="form-check form-check-inline dropdown-item">
              <input
                class="form-check-input"
                type="checkbox"
                id="alleroutes"
                value="checkall"
                (change)="
                  checkUncheckAllReferenceLevel($event, $event.target.checked)
                "
                [checked]="allReferenceLevelsChecked$ | async"
              />
              <label class="form-check-label" for="alleroutes">
                Alle profielen</label
              >
            </div>
          </label>
          <label
            *ngFor="let checkbox of referenceLevelsFilters$ | async"
            role="menuitem"
            class="form-check-label w-100"
            [for]="checkbox.name"
          >
            <div class="form-check form-check-inline dropdown-item">
              <input
                class="form-check-input"
                type="checkbox"
                [id]="checkbox.name"
                [checked]="checkbox.checked"
                (change)="
                  checkUncheckReferenceLevel(
                    $event,
                    $event.target.checked,
                    checkbox.id
                  )
                "
              />
              <label class="form-check-label" [for]="checkbox.name">
                {{ checkbox.name }}</label
              >
            </div>
          </label>
        </ul>
      </div>
      <div class="btn-group ml-auto">
        <button
          (click)="resetFilters()"
          class="btn btn-gray-light mdi mdi-close"
        >
          Filters wissen
        </button>
      </div>
    </div>
  </ng-container>
</ng-container>
